import client from '@/lib/axios-client'
import type {
	CreateInteracaoInput,
	Interacao,
	InteracaoAllListParams,
	InteracaoAllListResponse,
	InteracaoListParams,
	InteracaoListResponse,
	InteracaoMeListParams,
	InteracaoMeListResponse,
	InteracaoUpdateInput,
} from '@/types/interacao'

const INTERACAO_URL = '/interacoes'

export async function getInteracaoList(
	params?: InteracaoListParams,
): Promise<InteracaoListResponse> {
	const response = await client.get(INTERACAO_URL, { params })
	return response.data.data
}

export async function getInteracaoMeList(
	params?: InteracaoMeListParams,
): Promise<InteracaoMeListResponse> {
	const response = await client.get(`${INTERACAO_URL}/me`, { params })
	return response.data.data
}

export async function getInteracaoAllList(
	params?: InteracaoAllListParams,
): Promise<InteracaoAllListResponse> {
	const response = await client.get(`${INTERACAO_URL}/all`, { params })
	return response.data.data
}

export async function getInteracaoById(id: string): Promise<Interacao> {
	const response = await client.get(`${INTERACAO_URL}/${id}`)
	return response.data.data
}

export async function createInteracao(
	data: CreateInteracaoInput,
): Promise<Interacao> {
	const response = await client.post(INTERACAO_URL, data)
	return response.data.data
}

export async function updateInteracao(
	id: string,
	data: InteracaoUpdateInput,
): Promise<Interacao> {
	const response = await client.patch(`${INTERACAO_URL}/${id}`, data)
	return response.data.data
}

export async function deleteInteracao(id: string): Promise<void> {
	await client.delete(`${INTERACAO_URL}/${id}`)
}
